/**
 * Sorts a query string's params alphabetically by key (and by value within
 * comma-separated multi-value params) so that two URLs differing only by
 * parameter order compare as equal. Used when building `fromUrl` before
 * calling /api/v1/seo/redirect, per SEO requirement that redirect matching
 * must not depend on query param order.
 */
export const normalizeQueryString = (queryStr: string): string => {
  const searchParams = new URLSearchParams(queryStr);
  const sortedKeys = Array.from(new Set(Array.from(searchParams.keys()))).sort();

  const normalized = new URLSearchParams();
  sortedKeys.forEach((key) => {
    const rawValue = searchParams.get(key) || '';
    const sortedValue = rawValue.split(',').filter(Boolean).sort().join(',');
    normalized.set(key, sortedValue);
  });

  return normalized.toString();
};

/**
 * Builds a normalized `path?query` string (query params sorted) from a pathname
 * and a URLSearchParams-compatible query string.
 */
export const buildNormalizedPath = (pathname: string, queryStr: string): string => {
  const normalizedQuery = normalizeQueryString(queryStr);
  return normalizedQuery ? `${pathname}?${normalizedQuery}` : pathname;
};
